import axiosInstance from "../config/axios.config";

export const nurseInspectionAPI = (payload) => {
  return axiosInstance.post(`inpatient/nurse-initial-assessment/`, payload);
};
export const updateNurseInspectionAPI = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/nurse-initial-assessment/${id}/`,
    payload
  );
};

export const getNurseInspectionAPI = (admisssionId) => {
  return axiosInstance.get(
    `inpatient/nurse-initial-assessment/${admisssionId}/`
  );
};
export const getNurseCommonData = (admission_id, params, date) => {
  return date
    ? axiosInstance.get(
        `inpatient/nurse-care-items/${admission_id}/?type=${params}&date=${date}`
      )
    : axiosInstance.get(
        `inpatient/nurse-care-items/${admission_id}/?type=${params}`
      );
};
/*
 * Care items a nurse turned on for the admission because they were given as
 * SOS, rather than ordered by the doctor. They come back from
 * `nurse-care-items/<admission>/?type=care_items` alongside the ordered ones,
 * carrying the enabling nurse as `advised_by`.
 */
export const enableNurseCareItemApi = (admissionId, payload) => {
  return axiosInstance.post(
    `inpatient/nurse-care-items/${admissionId}/enabled/`,
    payload
  );
};
export const listEnabledNurseCareItemsApi = (admissionId) => {
  return axiosInstance.get(
    `inpatient/nurse-care-items/${admissionId}/enabled/`
  );
};
/*
 * The first SOS on a nurse-enabled care item. The item has no action row yet,
 * so this creates one and records the entry in the same call; later entries
 * go through updateNurseCommonData on the returned action id.
 */
export const recordNurseSosApi = (admissionId, payload) => {
  return axiosInstance.post(
    `inpatient/nurse-care-items/${admissionId}/sos/`,
    payload
  );
};

export const disableNurseCareItemApi = (enabledId) => {
  return axiosInstance.delete(
    `inpatient/nurse-care-items/enabled/${enabledId}/`
  );
};

export const updateNurseCommonData = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/nurse-care-items/update/${id}/`,
    payload
  );
};
export const getNurseMonitoringData = (admission_id, params) => {
  return params
    ? axiosInstance.get(`inpatient/monitoring-charts/${admission_id}/${params}`)
    : axiosInstance.get(`inpatient/monitoring-charts/${admission_id}/`);
};

export const updateNurseVitalsMonitoringApi = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/monitoring-charts/update/${id}/`,
    payload
  );
};
export const addVitalsMonitoringApi = (id, payload) => {
  return axiosInstance.post(`inpatient/monitoring-charts/${id}/`, payload);
};
export const getIoMonitoringData = (admission_id, params) => {
  return params
    ? axiosInstance.get(`inpatient/intake-output/${admission_id}/${params}`)
    : axiosInstance.get(`inpatient/intake-output/${admission_id}/`);
};
export const addIoMonitoringData = (id, payload) => {
  return axiosInstance.post(`inpatient/intake-output/${id}/`, payload);
};
export const updateIoMonitoringData = (admission_id, id, payload) => {
  return axiosInstance.patch(
    `inpatient/intake-output/${admission_id}/${id}/`,
    payload
  );
};
export const getNurseIpPatientApi = (params) => {
  return axiosInstance.get(`inpatient/nurse-ip-list/${params}`);
};
export const floorListApi = (params) => {
  return axiosInstance.get(`/facility/floor-list/${params}`);
};
export const nurseDailyRoutineApi = (id, payload) => {
  return axiosInstance.post(`inpatient/daily-routine-care/${id}/`, payload);
};
export const updateDailyRoutineApi = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/daily-routine-care/update/${id}/`,
    payload
  );
};
export const getNurseReviewDataApi = (id) => {
  return axiosInstance.get(`inpatient/nurse-review-data/${id}/`);
};
export function processAudioVitalsApi(formData) {
  return axiosInstance.post(
    "/careservices/ai-vision/process-audio-vitals/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}
export function processAudioGrbsApi(formData) {
  return axiosInstance.post(
    "/careservices/ai-vision/process-audio-grbs/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}
export function processAudioIoMonitoringApi(formData) {
  return axiosInstance.post(
    "/careservices/ai-vision/process-audio-io-monitoring/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}
